import React from 'react'
import { Trans } from 'translations'

const BaseKnowledgeLink = ({ link }: { link: string }) => {
    return (
        <p className="body1 knowledge-link">
            <Trans
                i18nKey="uiComponents.typography.needHelpKnowledgeBase"
                components={{ anchor: <a target="_blank" href={link} rel="noreferrer" className="bk-link" /> }}
            />
        </p>
    )
}

export default BaseKnowledgeLink
